import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { Dialog } from './dialog';
import { signin } from 'app/infrastructure/auth';
import { ButtonPrimary, ButtonTertiary } from 'ui';

import styles from './auth.scss';

type LogoutProps = DefaultContainerProps;

export class LogoutComponent extends React.Component<LogoutProps, any> {
  public static statePath: string = STATE.app;

  private onClickLogIn = () => {
    signin(false, false);
  };

  private onClickLogInAsDifferentUser = () => {
    signin(true, false);
  };

  public render() {
    return (
      <Dialog>
        <div >
          <div className={`${styles.iconAsBg} ${styles.successIcon}`} />
          <h1>
            {this.props.translation.logoutTitle}
          </h1>
          <div className={`${styles.buttonWrapper}`}>
            <ButtonPrimary classNames="btn-block" onClick={this.onClickLogIn}>
              {this.props.translation.logoutButton}
            </ButtonPrimary>
            <ButtonTertiary classNames="btn-block" onClick={this.onClickLogInAsDifferentUser}>
              {this.props.translation.logoutButtonDifferentUser}
            </ButtonTertiary>
          </div>
        </div>
      </Dialog>
    );
  }
}

const container = containerFactory(LogoutComponent, null);

export { container as Logout };
